import React from "react";
import { useLocation } from "react-router-dom";

function CurrentPage() {
    const { pathname } = useLocation();
    return <h2 id="pageTitle">{pathname === "/" ? "Home" : pathname.replace("/","")}</h2>;
}

export default CurrentPage;
